import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const NPAOFMN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/npaofmn/logo.png",
        alt: "Northern Psychiatric Associates Logo",
        style: { width: "270px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 48,
  state: "MN",
  departmentIds: [
    220, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433,
  ],
};
